import Begining from "./components/begining/Begining";
import ContactUs from "./components/contactUs/ContactUs";
import Hardwares from "./components/hardwares/Hardwares";
import Header from "./components/header/Header";
import MainBenefits from "./components/mainBenefits/MainBenefits";
import Navbar from "./components/navbar/Navbar";
import Statistics from "./components/statistics/Statistics";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Begining />
      <Statistics />
      <MainBenefits />
      <Hardwares />
      <ContactUs />
    </div>
  );
}

export default App;
